import styled from "styled-components";

export const SearchWrapper = styled.div`
    position: relative;
    width: 100%;
    max-width: 540px;
`;

export const SuggestionsDropdown = styled.ul`
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    list-style: none;
    margin: 0;
    padding: 4px 0;
    z-index: 1000;
    max-height: 320px;
    overflow-y: auto;

    scrollbar-width: thin;
    scrollbar-color: #d0d0d0 transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
        margin: 12px 0;
    }

    &::-webkit-scrollbar-thumb {
        background: #d0d0d0;
        border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #b0b0b0;
    }
`;

export const SuggestionItem = styled.li`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px;
    cursor: pointer;
    font-size: 14px;
    color: var(--bs-secondary);

    &:hover {
        background: #f5f5f5;
        color: var(--bs-primary);
    }
`;

export const SuggestionThumb = styled.img`
    width: 36px;
    height: 36px;
    object-fit: contain;
    flex-shrink: 0;
    border-radius: 4px;
`;

export const SuggestionName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    
    max-width: 540px;
    height: 44px;

    background: white;
    border-radius: 999px;
    padding: 0 18px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
`;

export const SearchInput = styled.input`
    flex: 1;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;

    font-size: 16px;
    color: var(--bs-secondary);

    &::placeholder {
        color: #9c9c9c;
    }
`;

export const SearchIconWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #9c9c9c;

    svg {
        font-size: 26px;
    }

    &:hover {
        color: var(--bs-primary);
    }
`;
